// NOTE: this file is not be used by the CLI but you have to keep this updated, read README.MD
const baseApiUrl = 'https://dev3.sintra-soh.com';
const apiUrl = `${baseApiUrl}/api/`;
const graphQlUrl = `${baseApiUrl}/pimcore-graphql-webservices/webapp`;

export const environment = {
  production: false,
  name: 'soh-retail',
  appName: 'SOH - App Retail',
  storageVersion: '',
  baseApiUrl,
  apiUrl,
  graphQlUrl,
  authInterceptorUrls: [apiUrl, graphQlUrl],
  mockApiUrl: 'https://localhost:3002/',
  sockets: { url: '' },
  tokenExpirationTimeLimit: 600000, // 10 minutes
  httpRetryConfig: {
    enabled: true,
    verbs: {
      get: { enabled: true, timeout: 30000, maxRetries: 2, retryForStatusesCodes: [500] },
      post: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      patch: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      put: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      delete: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
    },
  },
  graphQlConfig: {
    enabled: true,
    requestTimeout: 10000,
  },
  loggerConfig: {
    enabled: true,
    maxLogRentention: 20,
    logHttpErrorsWithStatusesCodes: ['0', '4XX', '5XX'],
    logDecoratedExceptions: true,
    logExceptions: true,
    saveLogMessagesInterval: 30000,
    logUrl: '',
    sendLogs: false,
    sendRequestBody: false,
    sendQueryParams: false,
  },
  tagManager: {
    enabled: false,
    apiKey: '',
  },
  registerServiceWorker: false,
  httpPassword: '',
  mainLogoUrl: '',
  customerLogoUrl: '',
  apiProperties: {
    size: 'size',
    sizeQuery: 'size',
    color: 'color',
    colorQuery: 'color',
  },
  returns: {
    isModuleEnabled: true,
    enableReturnedStatusButton: false,
  },
  clickCollect: {
    isModuleEnabled: true,
    showClickCollectCode: false,
  },
  shipFromStore: {
    isModuleEnabled: true,
    isUploadAccessoryFileEnabled: false,
  },
};
